import { render } from "./IconImage.vue?vue&type=template&id=2da49ae1"
const script = {}

import exportComponent from "/Users/david/Documents/GitHub/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconImage.vue"]])

export default __exports__